import React from 'react';
import {MagnifyingGlassIcon} from '@heroicons/react/24/solid';
import {useSelectedUserStore} from './chart/SelectedUserStore'; // Zustand importieren

const Settingtools = ({setSearchTerm}) => {
    const {clearSelectedUser} = useSelectedUserStore(); // clearSelectedUser verwenden

    const handleNewBauleiter = () => {
        clearSelectedUser(); // Zustand leeren und zurücksetzen
    };

    return (
        <main className='flex items-end'>
            <div className='px-3 py-2 bg-color-5 rounded-full flex items-center shadow-sm border border-color-2'>
                <div className='w-60 h-5 font-color-1 flex items-center'>
                    <div className='w-5 h-5'>
                        <MagnifyingGlassIcon/>
                    </div>
                    <input
                        type='text'
                        className='text-black text-sm font-light w-full bg-color-5 ml-2 focus:outline-none'
                        placeholder='Suche...'
                        onChange={(e) => setSearchTerm(e.target.value)} // Suchbegriff aktualisieren
                    />
                </div>
            </div>
            <button
                className='ml-4 px-3 py-2 bg-color-5 font-color-1 text-sm flex items-center shadow-sm border border-color-2 rounded-lg font-medium'
                onClick={handleNewBauleiter} // Popup für neuen Bauleiter öffnen
            >
                Neuer Bauleiter
            </button>
        </main>
    );
}

export default Settingtools;
